import FileUploadWrapper from "./FileUploadWrapper";

export default FileUploadWrapper;